/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/accounting.scss';
//component
import PopPay from '../student/_PopPay'; //결제하기
import Tab from '../../component/Inc/Tab';
function AccountingSubjectUndeposited() {
  const [modalOpenPay, setModalOpenPay] = useState(false);
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const tab01 = [
    {title: '국어', value: 0},
    {title: '영어', value: 1},
    {title: '수학', value: 2},
    {title: '사탐', value: 3},
    {title: '과탐', value: 4},
    {title: '논술', value: 5},
    {title: '면접', value: 6},
    {title: '생디', value: 7}
  ];
  return (
    <main className="com_container">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_3 active">과목별 미입금 관리</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">주간</button>
                  <button className="com_btn line gray s">월간</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <div className="com_count_wrapper">
                  <div className="operators">
                    <div className="operators_label">
                      <span className="operators_count">총 입금 건수</span>
                      <span className="operators_value">98건</span>
                    </div>
                  </div>
                  <div className="turnover">
                    <div className="turnover_label">
                      <span className="turnover_count">총 입금액</span>
                      <span className="turnover_value">46,500,000</span>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="50" />
                <col width="120" />
                <col width="80" />
                <col width="80" />
                <col width="80" />
                <col width="110" />
                <col width="110" />
                <col width="85" />
                <col width="85" />
                <col width="120" />
                <col width="120" />
                <col width="80" />
                <col width="110" />
                <col width="100" />
                <col width="120" />
                <col width="70" />
                <col width="70" />
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                    <label htmlFor="chkAll" />
                  </th>
                  <th>
                    최근 입금일 &nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>학생</th>
                  <th>과목</th>
                  <th>구분</th>
                  <th>할인</th>
                  <th>상품가격</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>입금된 회차 / 금액</th>
                  <th>
                    입금 예정일 &nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>상태</th>
                  <th>미입금 누적회차</th>
                  <th>회차 / T</th>
                  <th>미입금액</th>
                  <th>결제하기</th>
                  <th>보기</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                    <label htmlFor="chkAll" />
                  </td>
                  <td>2022, 08, 25</td>
                  <td><button className="btn_link">김학생103</button></td>
                  <td>과탐</td>
                  <td>본사</td>
                  <td>형제할인 2%</td>
                  <td>466,000</td>
                  <td><button className="btn_link">홍길동103</button></td>
                  <td><button className="btn_link">홍담임204</button></td>
                  <td className="td_point">3회 / 300,000</td>
                  <td>2022, 08, 25</td>
                  <td className="com_red_txt">종료</td>
                  <td className="com_red_txt">6</td>
                  <td>16회 / 2T</td>
                  <td>1,234,000</td>
                  <td>
                    <button className="com_blue_txt btn_link" onClick={() => setModalOpenPay(true)}>
                      결제
                    </button>
                  </td>
                  <td className="td_point">
                    <button className="txt btn_link">보기</button>
                  </td>
                </tr>
                {[...Array(8)].map((i, idx) => (
                  <tr key={idx}>
                    <td className="bg_col">
                      <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                      <label htmlFor="chkAll" />
                    </td>
                    <td className="bg_col">2022, 08, 25</td>
                    <td className="bg_col"><button className="btn_link">김학생103</button></td>
                    <td className="bg_col">과탐</td>
                    <td className="bg_col">본사</td>
                    <td className="bg_col">형제할인 2%</td>
                    <td className="bg_col">466,000</td>
                    <td className="bg_col"><button className="btn_link">홍길동103</button></td>
                    <td className="bg_col"><button className="btn_link">홍담임204</button></td>
                    <td className="bg_col td_point">3회 / 300,000</td>
                    <td className="bg_col">2022, 08, 25</td>
                    <td className="bg_col td_point">진행</td>
                    <td className="bg_col com_red_txt">6</td>
                    <td className="bg_col">16회 / 2T</td>
                    <td className="bg_col">1,234,000</td>
                    <td className="bg_col">
                      <button className="com_blue_txt btn_link" onClick={() => setModalOpenPay(true)}>
                        결제
                      </button>
                    </td>
                    <td className="bg_col td_point">
                      <button className="com_blue_txt btn_link">보기</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="com_btn_wrap">
              <button className="com_btn black xs">선택항목 다운로드</button>
            </div>
          </div>
        </section>
      </div>
      <PopPay open={modalOpenPay} close={() => setModalOpenPay(false)} />
    </main>
  );
}

export default AccountingSubjectUndeposited;
